export const LogoMark = ({ className = "h-11 w-11" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="12" fill="#0B1B33" />
    <text x="32" y="40" textAnchor="middle" fontFamily="Bricolage Grotesque, sans-serif" fontWeight="800" fontSize="21" fill="#fff" letterSpacing="0.5">AOR</text>
    <rect x="12" y="47" width="40" height="3" rx="1.5" fill="#14B8A6" />
  </svg>
);

export const Logo = ({ sub = "AI PROJECT PROOF COHORT", light = false, testId = "nav-logo" }) => (
  <a href="/go" data-testid={testId} className="flex items-center gap-3 group">
    <LogoMark className={`h-11 w-11 transition-transform duration-300 group-hover:-rotate-6 ${light ? "rounded-xl ring-1 ring-white/40" : ""}`} />
    <span className="leading-tight">
      <span className={`font-display block text-[21px] font-bold tracking-tight ${light ? "text-white" : "text-[#0B1B33]"}`}>ArtOfResume</span>
      <span className={`block text-[10.5px] font-semibold tracking-[0.08em] ${light ? "text-slate-300" : "text-slate-600"}`}>{sub}</span>
    </span>
  </a>
);
